import { Grid, Skeleton } from '@mui/material';
import type { ReactNode } from 'react';

import FormInputRowLabel from '../FormInputRowLabel';

interface Props {
  label?: string | ReactNode;
  field?: ReactNode;
  tooltipText?: string;
  error?: ReactNode;
  loading?: boolean;
  labelAlignItems?: 'flex-start' | 'center' | 'flex-end';
}

export default function FormInputRow({
  label,
  field,
  tooltipText,
  error,
  loading,
  labelAlignItems,
}: Props) {
  const fieldComp = loading ? (
    <Skeleton
      animation="wave"
      width="100%"
    />
  ) : (
    field
  );

  return (
    <Grid
      container
      wrap="nowrap"
      data-testid="form-input-row"
      sx={{
        columnGap: 4,
        alignItems: 'start',
      }}
    >
      <Grid
        size={{
          xs: 12,
          sm: 12,
          md: 12,
          lg: 3,
          xl: 3,
        }}
        sx={{
          display: 'flex',
          alignItems: labelAlignItems ? labelAlignItems : 'center',
        }}
      >
        <FormInputRowLabel
          label={label}
          tooltipText={tooltipText}
        />
      </Grid>
      <Grid
        sx={{ overflow: 'hidden' }}
        size="grow"
      >
        {error ? error : fieldComp}
      </Grid>
    </Grid>
  );
}
